import SuggestedActionInstance from './SuggestedActionInstance.component';

export default SuggestedActionInstance;
